import { BaseMapper } from '@ps/utils';
import { TemplateFolder, TemplateSummary } from '@ps/survey-utils';

import {
  TemplateFolderDto,
  TemplateSummaryDto,
} from '../../dtos/template-folder.dto';

export class SurveyTemplateMapper extends BaseMapper<
  TemplateFolderDto,
  TemplateFolder
> {
  public fromDto(dto: TemplateFolderDto): TemplateFolder {
    return {
      id: dto.id,
      name: dto.name,
      templates: dto.templates.map((subfolder) =>
        this._fromSummaryDto(subfolder),
      ),
      subfolders: dto.subfolders?.map((subfolder) => this.fromDto(subfolder)),
    };
  }

  private _fromSummaryDto(dto: TemplateSummaryDto): TemplateSummary {
    return {
      id: dto.id,
      name: dto.name,
    };
  }
}
